module.exports = __webpack_public_path__ + "img/delhivery.58b64704.jpg";